import { injectable } from '@servicetitan/react-ioc';
import { observable, computed } from 'mobx';

export interface PGResponse {
    Type: PaymentGatewayResponseType;
    Data: ResponseData;
}

interface ResponseData {
    Token: string;
    Number: string;
    CardholderName: string;
    ExpMonth: string;
    ExpYear: string;
    Cvc: string;
    IssuerName: string | undefined;
}

export enum PaymentGatewayResponseType {
    Error = 0,
    Submit = 1,
    SearsCard = 2,
}

@injectable()
export class PaymentGateway {
    @observable baseUrl: string = '';
    @observable apiKey: string = '';
    @observable paymentsServiceJwt: string = '';
    @observable paymentsServiceCreditCardProcessorExists: boolean = false;

    private tokenizationCompleteCallback?: (response: PGResponse) => void;

    getDesktopPaymentGatewayUrl(usePaymentsService: boolean | undefined = undefined): string {
        return this.getPaymentGatewayUrl('PortalDesktop', usePaymentsService);
    }

    getMobilePaymentGatewayUrl(usePaymentsService: boolean | undefined = undefined): string {
        return this.getPaymentGatewayUrl('PortalMobile', usePaymentsService);
    }

    getPaymentGatewayUrl = (view: string, usePaymentsService: boolean | undefined = undefined) => {
        // tslint:disable-next-line: prefer-template
        let url = `${this.baseUrl}/Forms/CreditCard?view=${view}&key=${this.apiKey}&origin=${window.location.origin}`;

        if (usePaymentsService === true || (usePaymentsService !== false && this.paymentsServiceJwt?.length && this.paymentsServiceCreditCardProcessorExists)) {
            url +=
                `&paymentsServiceJwt=${encodeURIComponent(this.paymentsServiceJwt)}` +
                '&processor=PaymentsService';
        }

        return url;
    }
    iframeMessageHandler = (event: MessageEvent) => {
        if (!this.postMessageEventIsValid(event)) {
            return;
        }

        if (this.tokenizationCompleteCallback) {
            this.tokenizationCompleteCallback!(event.data);
            // reset the callback after every execution.
            this.tokenizationCompleteCallback = undefined;
        }
    };

    postMessageEventIsValid = (event: MessageEvent) => {
        const iframe = document.getElementById('payment-gateway') as HTMLIFrameElement;
        return event.origin === this.baseUrl && event.source === iframe.contentWindow;
    };

    handleSubmit = (
        callback: (response: PGResponse) => void,
        e?: React.FormEvent<HTMLFormElement>
    ) => {
        e && e.preventDefault();

        const pgIframe = document.getElementById('payment-gateway') as HTMLIFrameElement | null;
        if (!pgIframe || !pgIframe.contentWindow) {
            return;
        }

        pgIframe.contentWindow.postMessage({ key: 'st.paymentgateway.submit' }, this.baseUrl);
        this.tokenizationCompleteCallback = callback;
    };
}
